export default "__VITE_ASSET__lFI9BTHL__"